export default "__VITE_PUBLIC_ASSET__4aebab17__"